import { Component, inject } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Router, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { AnalyticsService } from './core/analytics/analytics.service';
import { LocaleService } from './core/locale.service';
import { PageHeader } from './layout/page-header/page-header';
import { TextCarousel } from './layout/text-carousel/text-carousel';
import { RegistrationFormsService } from './registration/forms/registration-forms.service';
import { RegistrationService, queryParams } from './registration/registration.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, PageHeader, TextCarousel],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly tips = ['tips.tip0', 'tips.tip1', 'tips.tip2'];

  constructor() {
    const params = queryParams(window.location.search);
    const lang = inject(LocaleService).resolve(params['lang']);
    inject(TranslateService).use(lang);

    const registration = inject(RegistrationService);
    registration.lang = lang;
    const stripped = registration.readParams(params);
    inject(RegistrationFormsService).prefill(params);
    if (stripped.length) {
      const rest = new URLSearchParams(params);
      stripped.forEach((key) => rest.delete(key));
      const query = rest.toString();
      inject(Router).navigateByUrl(`${window.location.pathname}${query ? `?${query}` : ''}`, { replaceUrl: true });
    }

    if (environment.ENV_NAME !== 'production') {
      inject(Meta).addTag({ name: 'robots', content: 'noindex' });
    }
    inject(AnalyticsService).start();
  }
}
